export const METHOD_OF_RECEIPT_KEYS = {
  novaPoshta: 'nova_pochta',
  meest: 'meest',
  delivery: 'delivery',
  justin: 'justin',
}

export const PAYMENT_METHODS = {
  card: 'card',
  cash: 'cash'
}

export const DELIVERY_METHODS = {
  department: 'Відділення',
  address: 'Адреса',
}

export const DELIVERY_METHODS_OPTIONS = Object.values(DELIVERY_METHODS).map((item) => ({ label: item, value: item }))
